import React, { ReactNode } from 'react';

const GamesLobbyWrapper = ({ children }: { children: ReactNode }) => (
  <div className="py-6 md:py-12 flex flex-col gap-8 sm:gap-12 md:gap-20 max-w-[1400px] mx-auto px-[16px] 2xl:px-0">
    {children}
  </div>
);

export default GamesLobbyWrapper;
